import IAddress1UnitNoZipCode from '../common/IAddress1UnitNoZipCode';
import ISalesHistory from './ISalesHistory';

export default interface ISalesHistoryProperty {
    address1UnitNoZipCode: IAddress1UnitNoZipCode;
    salesHistory: ISalesHistory;
}

export function newSalesHistoryProperty(address1UnitNoZipCode: IAddress1UnitNoZipCode): ISalesHistoryProperty {
    const property: ISalesHistoryProperty = {
        address1UnitNoZipCode: address1UnitNoZipCode,
        salesHistory: []
    };
    return property;
}
